import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Row, Col, Modal, Divider as AntDivider } from 'antd';
import classNames from 'classnames';
import { BookTwoTone, DollarOutlined, FilePdfOutlined, FilePdfTwoTone, FileTextTwoTone } from '@ant-design/icons';
import { Input, Form, Button, Table, Page, ContentWrapper, DatePicker, Select, Statistic, Loading } from '~/components';
import { ContaPagarService, FrequenciaService, PrincipalService, RelatorioService, UserService } from '~/services';
import { decimalPlace, decimalValue } from '~/utils';
import { colors } from '~/options';
import './FinanceiroPage.less';

class FinanceiroPage extends React.PureComponent {
  constructor(props) {
    super(props);

    this.comboSituacao = [
      { label: 'ABERTA', data: '0' },
      { label: 'BAIXADA', data: '9' },
    ];

    this.comboSituacaoBoleto = [
      { label: 'ABERTO', data: 'ABERTO' },
      { label: 'BAIXADO', data: 'BAIXADO' },
    ];

    this.rowColorCupom = [
      { title: 'ATRASADO', color: colors.volcano, predicate: item => item.situacao === 'ATRASADO' },
      { title: 'BAIXADO', color: colors.polarGreen, predicate: item => item.situacao === 'BAIXADO' },
      { title: 'VENCE HOJE', color: colors.sunriseYellow, predicate: item => item.situacao === 'VENCE HOJE' },
    ];

    this.rowColorCheque = [{ title: 'BAIXADO', color: colors.polarGreen, predicate: item => item.baixa && item.baixa !== '' }];

    this.rowColorBoleto = [
      { title: 'BAIXADO', color: colors.polarGreen, predicate: item => item.situacao === 'BAIXADO' },
      { title: 'PAGO PARCIAL', color: colors.grey, predicate: item => item.situacao === 'PAGO PARCIAL' },
      { title: 'VENCE HOJE', color: colors.sunriseYellow, predicate: item => item.situacao === 'VENCE HOJE' },
      { title: 'ATRASADO', color: colors.volcano, predicate: item => item.situacao === 'ATRASADO' },
      { title: 'ABERTO', color: colors.cyan, predicate: item => item.situacao === 'ABERTO' },
    ];

    this.state = {
      isLoadingCredito: false,
      isLoadingContato: false,
      isLoadingPDF: false,
      isLoadingNotas: false,
      isLoadingCheques: false,
      isLoadingBoletos: false,
      itensNotas: [],
      itensCheques: [],
      itensBoletos: [],
      selectedItemNotas: {},
      selectedItemCheques: {},
      selectedItemBoletos: {},
      empresas: [],
      dataItemsContato: [],
      valorCredito: 0,
      valorCreditoAberto: 0,
      activeTab: 'cupom',
    };
  }

  componentDidMount() {
    const { params } = this.props;

    this.buscarContato('FINANCEIRO');
    this.buscarCredito();

    UserService.fetchEmpresas(empresas => this.setState({ empresas }));

    if (params && Object.keys(params).length > 0) {
      if (params.tab === 'boletos') {
        this.setState({ activeTab: 'boletos' });
        this.handleSearchBoletos({
          status: '0',
          data_inicial: '2000-01-01',
          data_final: moment()
            .add(3, 'year')
            .format('YYYY-MM-DD'),
          desbloquear: true,
        });
      } else if (params.tab === 'cupom') {
        this.searchApiNotas.setValues({
          data_inicial: moment()
            .add(-30, 'days')
            .format('YYYY-MM-DD'),
        });
        this.searchApiNotas.submitForm();
      }
    }
  }

  buscarCredito = () => {
    const { user } = this.props;

    this.setState({ isLoadingCredito: true }, () => {
      PrincipalService.getAllFinanceiro(
        user.codigo,
        response => {
          this.setState({
            valorCredito: parseFloat(response[0].limite_credito),
            valorCreditoAberto: parseFloat(response[0].valor_aberto),
            isLoadingCredito: false,
          });
        },
        () => this.setState({ valorCredito: 0, valorCreditoAberto: 0, isLoadingCredito: false })
      );
    });
  };

  buscarContato = arquivo => {
    this.setState({ isLoadingContato: true }, () => {
      PrincipalService.getAllContato(
        arquivo,
        dataItemsContato => this.setState({ dataItemsContato, isLoadingContato: false }),
        () => this.setState({ dataItemsContato: [], isLoadingContato: false })
      );
    });
  };

  // CUPOM / NOTA FISCAL
  handleSearchNotas = values => {
    if (moment(values.data_final).diff(values.data_inicial, 'days') > 365) {
      Modal.error({
        title: 'Financeiro - Cupom / Nota Fiscal',
        content: 'O período máximo permitido é de 1 ano. Para mais informações entre em contato com o nosso atendimento.',
        centered: true,
        width: '550px',
      });
      return;
    }

    this.setState({ isLoadingNotas: true }, () => {
      ContaPagarService.getAllCupomNota(
        { ...values },
        itensNotas => this.setState({ itensNotas, isLoadingNotas: false }, () => this.searchInputNotas.focus()),
        () => this.setState({ isLoadingNotas: false })
      );
    });
  };

  imprimirCupomNota = (record, tipo) => {
    if (tipo === 'xml') {
      this.gerarXML(record);
    } else if (tipo === 'resumida') {
      this.imprimirCupom({ ...record, modelo: '55', tipo_retorno: 'pdfr' });
    } else if (record.tipo === 'CUPOM') {
      this.imprimirCupom({ ...record, modelo: '65', tipo_retorno: 'pdf' });
    } else {
      this.imprimirNota(record);
    }
  };

  imprimirCupom = record => {
    this.setState({ isLoadingPDF: true }, () => {
      FrequenciaService.consultarCupom(
        { ...record, retorno: 'pdf' },
        response => {
          if (response.toString().indexOf(' encontrado') === -1) {
            /*
            NÃO CONSEGUI FAZER SALVAR DIRETO O ARQUIVO
            if (tipo !== 'pdf') {
              window.open(
                `${process.env.REACT_APP_URL}${window.location.hostname}/arquivo/baixar.php?arquivo=${response.toString().replace('arquivo/', '')}`,
                '_blank'
              );
            }
            */
            window.open(`${process.env.REACT_APP_URL}/${response.toString()}`, '_blank');
          } else {
            Modal.error({ content: response.toString(), title: 'Consulta Cupom', centered: true });
          }
          this.setState({ isLoadingPDF: false });
        },
        () => this.setState({ isLoadingPDF: false })
      );
    });
  };

  imprimirNota = record => {
    this.setState({ isLoadingPDF: true }, () => {
      const values = [];
      values.push({ nome_campo: 'codigo', valor: record.idt });
      values.push({ nome_campo: 'chave', valor: record.chave });
      values.push({ nome_campo: 'webnfe3', valor: 'S' });
      values.push({
        nome_campo: 'periodo',
        valor: `20${record.chave.substr(2, 4)}`,
      });

      RelatorioService.getChamaRelatorio(values, 'ServletDanfe', 'Nota Fiscal', () => this.setState({ isLoadingPDF: false }));
    });
  };

  gerarXML = record => {
    this.setState({ isLoadingPDF: true }, () => {
      ContaPagarService.gerarXML(
        record,
        response => {
          if (response !== '') {
            window.open(`${process.env.REACT_APP_URL}arquivo/baixar.php?arquivo=${response.toString()}`, '_blank');
          } else {
            Modal.error({ content: 'Erro ao buscar o XML. Tente novamente ou entre em contato com o Suporte.', title: 'Cupom / Nota Fiscal', centered: true });
          }
          this.setState({ isLoadingPDF: false });
        },
        () => this.setState({ isLoadingPDF: false })
      );
    });
  };

  // CHEQUE
  handleSearchCheques = values => {
    if (moment(values.data_final).diff(values.data_inicial, 'days') > 365) {
      Modal.error({
        title: 'Cheques',
        content: 'O período máximo permitido é de 1 ano. Para mais informações entre em contato com o nosso atendimento.',
        centered: true,
      });
      return;
    }

    this.setState({ isLoadingCheques: true }, () => {
      ContaPagarService.getAllCheque(
        values,
        itensCheques => this.setState({ itensCheques, isLoadingCheques: false }, () => this.searchInputCheques.focus()),
        () => this.setState({ isLoadingCheques: false })
      );
    });
  };

  // BOLETO
  handleSearchBoletos = values => {
    if (moment(values.data_final).diff(values.data_inicial, 'days') > 365 && !values.desbloquear) {
      Modal.error({
        title: 'Boletos',
        content: 'O período máximo permitido é de 1 ano. Para mais informações entre em contato com o nosso atendimento.',
        centered: true,
      });
      return;
    }

    this.setState({ isLoadingBoletos: true }, () => {
      ContaPagarService.getAllBoleto(
        values,
        itensBoletos => this.setState({ itensBoletos, isLoadingBoletos: false }, () => this.searchInputBoletos.focus()),
        () => this.setState({ isLoadingBoletos: false })
      );
    });
  };

  // IMPRIMIR
  imprimirFatura = record => {
    const values = [];
    values.push({ nome_campo: 'codigo', valor: record.numero_fatura });
    values.push({ nome_campo: 'reemissao', valor: 'S' });

    RelatorioService.getChamaRelatorio(values, 'ServletCobranca', 'Reemissão de Carta');
  };

  imprimirBoleto = record => {
    this.setState({ isLoadingPDF: true }, () => {
      ContaPagarService.gerarBoleto(
        record,
        response =>
          this.setState({ isLoadingPDF: false }, () =>
            window.open(`https://erp.mysaas.com.br/arquivo/empresa/${response.pasta}/${response.arquivo}`, '_blank')
          ),
        () => this.setState({ isLoadingPDF: false })
      );
    });
  };

  imprimirCarta = record => {
    const values = [];
    values.push({ nome_campo: 'idt_receber', valor: record.lista_agrupamento_receber });
    values.push({ nome_campo: 'reemissao', valor: 'S' });

    this.setState({ isLoadingPDF: true });

    RelatorioService.getChamaRelatorio(
      values,
      'ServletCobranca',
      'Reemissão de Carta',
      () => this.setState({ isLoadingPDF: false }),
      () => this.setState({ isLoadingPDF: false })
    );
  };

  render() {
    const { tabId } = this.props;
    const {
      isLoadingCredito,
      isLoadingContato,
      isLoadingPDF,
      empresas,
      dataItemsContato,
      valorCredito,
      valorCreditoAberto,
      activeTab,
      isLoadingNotas,
      itensNotas,
      selectedItemNotas,
      isLoadingCheques,
      itensCheques,
      selectedItemCheques,
      isLoadingBoletos,
      itensBoletos,
      selectedItemBoletos,
    } = this.state;

    return (
      <>
        <div className="conteudo-box financeiro">
          <div className="form borda">
            <Page tabbed tabId={tabId} activeKey={activeTab} onChange={activeKey => this.setState({ activeTab: activeKey })}>
              {/* CUPOM /  NOTA FISCAL */}
              <Page.TabPane key="cupom" tab="Cupom / Nota Fiscal">
                <Form getApi={api => (this.searchApiNotas = api)} onSubmit={this.handleSearchNotas}>
                  <ContentWrapper type="search">
                    <Row gutter={4}>
                      <Col md={12}>
                        <Select field="origem" label="Empresa" dataSource={empresas} allowClear disabled={isLoadingNotas} />
                      </Col>
                      <Col md={3}>
                        <Input
                          field="placa"
                          label="Placa"
                          disabled={isLoadingNotas}
                          type="alfaNumerico"
                          allowClear
                          forwardedRef={ref => (this.searchInputNotas = ref)}
                        />
                      </Col>
                      <Col md={3}>
                        <DatePicker field="data_inicial" label="Emissão Inicial" required today disabled={isLoadingNotas} />
                      </Col>
                      <Col md={3}>
                        <DatePicker field="data_final" label="Emissão Final" required today disabled={isLoadingNotas} />
                      </Col>
                      <Col md={3}>
                        <Button.Search loading={isLoadingNotas || isLoadingPDF} />
                      </Col>
                    </Row>
                  </ContentWrapper>
                </Form>
                <Table
                  dataSource={itensNotas}
                  rowKey="idt"
                  loading={isLoadingNotas}
                  record={selectedItemNotas}
                  rowColor={this.rowColorCupom}
                  onRecordChange={record => this.setState({ selectedItemNotas: record })}
                  description={item => (
                    <Row>
                      <Col>
                        <span style={{ fontSize: '0.8rem' }}>{item.placa}</span>
                      </Col>
                      <Col>
                        <span>{item.emissao}</span>
                      </Col>
                    </Row>
                  )}
                >
                  <Table.Column width="8%" title="Nota" dataIndex="nota" align="center" />
                  <Table.Column width="8%" title="Emissão" dataIndex="emissao" type="date" />
                  <Table.Column width="24%" title="Empresa" dataIndex="nome_empresa" />
                  <Table.Column width="8%" title="Placa" dataIndex="placa" align="center" />
                  <Table.Column width="14%" title="Tipo" dataIndex="tipo" align="center" />
                  <Table.Column width="10%" title="Valor (R$)" dataIndex="valor" type="currency" />
                  <Table.Column
                    title="Ações"
                    dataIndex="actions"
                    width="10%"
                    align="center"
                    exporter={false}
                    sorter={false}
                    render={(text, record) => (
                      <>
                        <FilePdfTwoTone
                          onClick={() => this.imprimirCupomNota(record)}
                          title="PDF"
                          twoToneColor="#cc0000"
                          className={classNames(isLoadingPDF ? 'icon-disabled' : '', 'icon-table-margin')}
                        />
                        <AntDivider type="vertical" />
                        <BookTwoTone
                          onClick={() => this.imprimirCupomNota(record, 'resumida')}
                          title="NF-e Resumida"
                          twoToneColor="#005fcc"
                          className={classNames(isLoadingPDF || record.tipo !== 'NOTA' ? 'icon-disabled' : '', 'icon-table-margin')}
                        />
                        <AntDivider type="vertical" />
                        <FileTextTwoTone
                          onClick={() => this.imprimirCupomNota(record, 'xml')}
                          title="XML NFC-e"
                          twoToneColor="#00cc00"
                          className={classNames(isLoadingPDF ? 'icon-disabled' : '', 'icon-table-margin')}
                        />
                      </>
                    )}
                  />
                </Table>
                <ContentWrapper type="header">
                  <Row>
                    <Col md={6} />
                    <Col md={6} style={{ textAlign: 'center' }}>
                      <Statistic
                        style={{ textAlign: 'center' }}
                        title="R$ Total Cupom"
                        value={decimalValue(
                          itensNotas.filter(item => item.tipo === 'CUPOM').reduce((previous, current) => parseFloat(current.valor) + previous, 0),
                          2
                        )}
                        color="#3f8600"
                      />
                    </Col>
                    <Col md={6} style={{ textAlign: 'center' }}>
                      <Statistic
                        style={{ textAlign: 'center' }}
                        title="R$ Total NF-e"
                        value={decimalValue(
                          itensNotas.filter(item => item.tipo === 'NOTA').reduce((previous, current) => parseFloat(current.valor) + previous, 0),
                          2
                        )}
                        color="#3f8600"
                      />
                    </Col>
                  </Row>
                </ContentWrapper>
              </Page.TabPane>

              {/* CHEQUE */}
              <Page.TabPane key="cheques" tab="Cheques">
                <Form getApi={api => (this.searchApiCheques = api)} onSubmit={this.handleSearchCheques}>
                  <ContentWrapper type="search">
                    <Row gutter={4}>
                      <Col md={9}>
                        <Select field="origem" label="Empresa" dataSource={empresas} allowClear disabled={isLoadingCheques} />
                      </Col>
                      <Col md={3}>
                        <Input
                          field="placa"
                          label="Placa"
                          disabled={isLoadingCheques}
                          type="placa"
                          allowClear
                          forwardedRef={ref => (this.searchInputCheques = ref)}
                        />
                      </Col>
                      <Col md={3}>
                        <Select
                          field="status"
                          label="Situação"
                          dataSource={this.comboSituacao}
                          allowClear
                          forceZero
                          disabled={isLoadingCheques}
                          initialValue="0"
                        />
                      </Col>
                      <Col md={3}>
                        <DatePicker field="data_inicial" label="Emissão Inicial" required today disabled={isLoadingCheques} />
                      </Col>
                      <Col md={3}>
                        <DatePicker field="data_final" label="Emissão Final" required today disabled={isLoadingCheques} />
                      </Col>
                      <Col md={3}>
                        <Button.Search loading={isLoadingCheques} />
                      </Col>
                    </Row>
                  </ContentWrapper>
                </Form>
                <Table
                  dataSource={itensCheques}
                  rowKey="idt"
                  loading={isLoadingCheques}
                  record={selectedItemCheques}
                  onRecordChange={record => this.setState({ selectedItemCheques: record })}
                  rowColor={this.rowColorCheque}
                >
                  <Table.Column width="25%" title="Empresa" dataIndex="nome_empresa" />
                  <Table.Column width="10%" title="Placa" dataIndex="placa" align="center" />
                  <Table.Column width="10%" title="Banco" dataIndex="banco" align="center" />
                  <Table.Column width="10%" title="Número" dataIndex="numero" align="center" />
                  <Table.Column width="15%" title="Banda" dataIndex="banda" align="center" />
                  <Table.Column width="10%" title="Emissão" dataIndex="emissao" type="date" />
                  <Table.Column width="10%" title="Vencimento" dataIndex="vencimento" type="date" />
                  <Table.Column width="10%" title="Valor (R$)" dataIndex="valor" type="currency" />
                </Table>
                <ContentWrapper type="header">
                  <Row>
                    <Col md={9} />
                    <Col md={6} style={{ textAlign: 'center' }}>
                      <Statistic
                        style={{ textAlign: 'center' }}
                        title="Valor Total (R$)"
                        value={decimalValue(
                          itensCheques.reduce((previous, current) => parseFloat(current.valor) + previous, 0),
                          2
                        )}
                        color="#3f8600"
                      />
                    </Col>
                  </Row>
                </ContentWrapper>
              </Page.TabPane>

              {/* BOLETO */}
              <Page.TabPane key="boletos" tab="Boletos">
                <Form getApi={api => (this.searchApiBoletos = api)} onSubmit={this.handleSearchBoletos}>
                  <ContentWrapper type="search">
                    <Row gutter={4}>
                      <Col md={9}>
                        <Select field="origem" label="Empresa" dataSource={empresas} allowClear disabled={isLoadingBoletos} />
                      </Col>
                      <Col md={3}>
                        <Input
                          field="placa"
                          label="Placa"
                          disabled={isLoadingBoletos}
                          type="placa"
                          allowClear
                          forwardedRef={ref => (this.searchInputBoletos = ref)}
                        />
                      </Col>
                      <Col md={3}>
                        <Select
                          field="status"
                          label="Situação"
                          dataSource={this.comboSituacaoBoleto}
                          allowClear
                          forceZero
                          disabled={isLoadingBoletos}
                          initialValue="ABERTO"
                        />
                      </Col>
                      <Col md={3}>
                        <DatePicker field="data_inicial" label="Vencimento Inicial" required today disabled={isLoadingBoletos} />
                      </Col>
                      <Col md={3}>
                        <DatePicker field="data_final" label="Vencimento Final" required today disabled={isLoadingBoletos} />
                      </Col>
                      <Col md={3}>
                        <Button.Search loading={isLoadingBoletos} />
                      </Col>
                    </Row>
                  </ContentWrapper>
                </Form>
                <Table
                  dataSource={itensBoletos}
                  rowKey="idt"
                  loading={isLoadingBoletos}
                  record={selectedItemBoletos}
                  rowColor={this.rowColorBoleto}
                  onRecordChange={record => this.setState({ selectedItemBoletos: record })}
                >
                  <Table.Column width="35%" title="Empresa" dataIndex="nome_empresa" />
                  <Table.Column width="15%" title="Emissão" dataIndex="emissao" type="date" />
                  <Table.Column width="15%" title="Vencimento" dataIndex="vencimento" type="date" />
                  <Table.Column
                    width="15%"
                    title="Fatura"
                    dataIndex="fatura"
                    type="integer"
                    /*
                    render={(text, record) => (
                      <Link align="center" onClick={() => this.imprimirFatura(record)}>
                        {text || ''}
                      </Link>
                    )}
                    */
                  />
                  <Table.Column width="15%" title="Valor (R$)" dataIndex="valor" type="currency" />
                  <Table.Column
                    width="5%"
                    title="Ações"
                    dataIndex="actions"
                    align="center"
                    exporter={false}
                    sorter={false}
                    render={(text, record) => (
                      <>
                        <FilePdfOutlined
                          onClick={() => this.imprimirCarta(record)}
                          title="Imprimir Carta de Cobrança"
                          className={classNames(isLoadingPDF ? 'icon-disabled' : '', 'icon-table-margin')}
                        />
                        <AntDivider type="vertical" />
                        <DollarOutlined
                          onClick={() => this.imprimirBoleto(record)}
                          title="Imprimir Boleto"
                          twoToneColor="#0000ff"
                          className={classNames(
                            record.situacao === 'BAIXADO' || record.situacao === 'PAGO PARCIAL' || isLoadingPDF ? 'icon-disabled' : '',
                            'icon-table-margin'
                          )}
                        />
                      </>
                    )}
                  />
                </Table>
                <ContentWrapper type="header">
                  <Row>
                    <Col md={9} />
                    <Col md={6} style={{ textAlign: 'center' }}>
                      <Statistic
                        style={{ textAlign: 'center' }}
                        title="Valor Total (R$)"
                        value={decimalValue(
                          itensBoletos.reduce((previous, current) => parseFloat(current.valor) + previous, 0),
                          2
                        )}
                        color="#3f8600"
                      />
                    </Col>
                  </Row>
                </ContentWrapper>
              </Page.TabPane>
            </Page>
          </div>

          <div className="painel-box">
            <div className="painel">
              <div className="aviso">
                <div className="titulo">Financeiro</div>
                <div className="texto">Nessa aba exibimos em detalhes toda a parte financeira!</div>
                <div className="texto">
                  <ul>
                    <li>Contas a Pagar</li>
                    <li>Consultas de Cheques</li>
                    <li>Cheques Trocados</li>
                    <li>Emissão de Notas</li>
                    <li>Boletos</li>
                  </ul>
                </div>

                <div className="contato">
                  <div>Dúvidas entre em contato com o setor responsável:</div>
                  {isLoadingContato ? (
                    <Loading />
                  ) : (
                    dataItemsContato.map(item => (
                      <div key={item.nome} className="destaque">
                        <a href={`https://api.whatsapp.com/send?phone=55${item.zap}`} target="_blank" rel="noopener noreferrer nofollow">
                          {`${item.telefone} ${item.nome}`}
                        </a>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>

            <div className="limite">
              <div className="linha">
                <div className="texto">Limite</div>
                <div className="valor azul">{isLoadingCredito ? <Loading /> : `R$  ${decimalPlace(valorCredito, 2)}`}</div>
              </div>
            </div>

            <div className="limite">
              <div className="linha">
                <div className="texto">Crédito Utilizado</div>
                <div className="valor amarelo">{isLoadingCredito ? <Loading /> : `R$  ${decimalPlace(valorCreditoAberto, 2)}`}</div>
              </div>
            </div>

            <div className="limite">
              <div className="linha">
                <div className="texto">Crédito Disponível</div>
                <div className="valor verde">{isLoadingCredito ? <Loading /> : `R$  ${decimalPlace(valorCredito - valorCreditoAberto, 2)}`}</div>
              </div>
            </div>
          </div>
          {/* FIM */}
        </div>
      </>
    );
  }
}

const mapStateToProps = ({ user }) => ({ user });

export default connect(mapStateToProps)(FinanceiroPage);
